// 引入axios对其进行二次封装

import axios from 'axios'
// 在一个普通的.js模块中（不是某个.vue组件）如何去获取vuex中保存的token值？
import store from '@/store/index.js'
import JSONBig from 'json-bigint' // 引入大数字包
import router from '../router'

// 设置基地址
const instance = axios.create({
    baseURL: '',
    headers: {
        "Content-Type": "application/json"
    },
    transformResponse: [function (data) {
        // 由于后端返回的数据有出现大数问题（文章编号）,这里使用json-bigint处理一下
        // 优先使用JSONBig转一下
        try {
            return JSONBig.parse(data)
        } catch (err) {
            return data
        }
    }]
})

// 给instance 添加请求拦截器，并给拦截器添加token信息
instance.interceptors.request.use(
    config => {
        if (store.state.token) {
            config.headers.common['token'] = store.state.token
        }
        return config;
    },
    error => {
        //对请求错误做什么
        return Promise.reject(error);
    })

// http reponse响应拦截器
instance.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    localStorage.removeItem('token');
                    router.replace({
                        path: '/login',
                        query: { redirect: router.currentRoute.fullPath } //登录成功后跳入浏览的当前页面
                    })
            }
        }
    })
export default instance